import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Tool} from '../../../model/tool';
import {DomSanitizer} from '@angular/platform-browser';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-tool-block',
    templateUrl: './tool-block.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        NgbTooltip
    ],
    styleUrls: ['./tool-block.component.css']
})
export class ToolBlockComponent implements OnInit {
  @Input() tool: Tool;
  @Input() adminMode = false;

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  html;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.tool.description);
  }
}
